<footer class="footer-container px-5 d-flex align-items-center justify-content-between h-100">
  <p class="version-text m-0 p-0">
    {{ 'backoffice.shell.footer.version' | translate: { version: version } }}
  </p>

  <p class="scope-text m-0 p-0">{{ 'backoffice.shell.footer.scope' | translate }}</p>
</footer>
